import { PromoRoutesEnum } from 'shared/constants/routes'
import { URLS } from 'shared/constants/urls'

import { BannerItem } from './types'

import simplifiedConditionsM from 'assets/img/promo-page/banners//simplifiedConditionsM.png'
import courierL from 'assets/img/promo-page/banners/courier-l.png'
import courierM from 'assets/img/promo-page/banners/courier-m.png'
import courierS from 'assets/img/promo-page/banners/courier-s.png'
import simplifiedConditionsL from 'assets/img/promo-page/banners/simplifiedConditionsL.png'
import simplifiedConditionsS from 'assets/img/promo-page/banners/simplifiedConditionsS.png'

export const banners: BannerItem[] = [
  {
    id: 1,
    linkType: 'path',
    link: PromoRoutesEnum.simplifiedConditions,
    imgDesktop: simplifiedConditionsL,
    imgTablet: simplifiedConditionsM,
    imgMobile: simplifiedConditionsS,
    name: 'Откройте пункт выдачи на упрощённых условиях',
  },
  {
    id: 2,
    link: URLS.wbCourier,
    linkType: 'link',
    imgDesktop: courierL,
    imgTablet: courierM,
    imgMobile: courierS,
    name: 'WB Курьер',
  },
]
